import React from 'react';
import { motion } from 'framer-motion';
import { Gift, MapPin, MessageSquare } from 'lucide-react';
const bonuses = [{
  icon: Gift,
  title: 'Calculadora Rentar vs Comprar (PDF)',
  description: 'Descubre si te conviene más seguir rentando o dar el paso a comprar según tus números exactos.'
}, {
  icon: MapPin,
  title: 'Lista de Programas de Ayuda por Estado',
  description: 'Encuentra programas de asistencia para el down payment específicos en tu estado o ciudad.'
}, {
  icon: MessageSquare,
  title: 'Guía de Preguntas para tu Lender',
  description: 'Las preguntas exactas que debes hacer antes de firmar cualquier préstamo para evitar sorpresas.'
}];
export function BonusSection() {
  return <section className="py-24 relative overflow-hidden pt-[10px] pb-[10px]" data-id="element-9">
      <div className="container mx-auto px-6 space-y-[10px]" data-id="element-10">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-11">
          {/* Text & Cards */}
          <div className="flex-1 w-full lg:order-2" data-id="element-12">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="mb-12 text-center lg:text-left" data-id="element-13">
              <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl mb-4" data-id="element-14">
                Además, Recibes Estos{' '}
                <span className="text-gold italic" data-id="element-15">Bonus Exclusivos</span>
              </h2>
              <p className="text-muted text-lg" data-id="element-16">
                Herramientas prácticas para acelerar tu proceso de compra.
              </p>
            </motion.div>

            <div className="space-y-6" data-id="element-17">
              {bonuses.map((bonus, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.15
            }} className="flex gap-6 bg-dark-card border border-gold/10 rounded-xl p-6 hover:border-gold/30 transition-colors" data-id="element-18">
                  <div className="w-12 h-12 rounded-full bg-gold/10 flex items-center justify-center shrink-0" data-id="element-19">
                    <bonus.icon className="w-6 h-6 text-gold" data-id="element-20" />
                  </div>
                  <div data-id="element-21">
                    <h3 className="text-lg font-semibold text-white mb-2" data-id="element-22">
                      {bonus.title}
                    </h3>
                    <p className="text-muted text-sm leading-relaxed" data-id="element-23">
                      {bonus.description}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="flex-1 w-full lg:order-1 relative" data-id="element-24">
            <div className="relative rounded-2xl overflow-hidden border border-white/10" data-id="element-25">
              <div className="absolute inset-0 bg-dark/40 z-10" data-id="element-26" />
              <img src="https://cdn.magicpatterns.com/uploads/ieQFQBwZiFRkXrzsYwxQoW/a6.jpg" alt="Casa en venta" className="w-full h-auto object-cover aspect-square lg:aspect-[4/5]" data-id="element-27" />

              {/* Overlay Badge */}
              
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}